import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../app';
import { ReferenceDataState } from '../../reducers/referenceData.reducer';

export interface IAdminContactEmailLinkProps {
    subject?: string;
    title?: string;

    referenceData?: ReferenceDataState;
}

class AdminContactEmailLink extends React.Component<IAdminContactEmailLinkProps, any> {
    constructor(props, context) {
        super(props, context);
    }


    render() {
        const { subject, title } = this.props;

        const queryPart = subject && subject.length > 0 ? '?subject=' + subject : '';

        const email = this.props.referenceData && this.props.referenceData.websiteSettings 
            ? this.props.referenceData.websiteSettings.adminContactEmail : undefined;

        return (email ? <a rel="noopener" href={`mailto:${email}${queryPart}`}>{title ? title : email}</a> : null);
    }
}

const mapStateToProps = (state: IAppState) => {

    return {
        referenceData: state.referenceData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminContactEmailLink);
